import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, supportedLanguages } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    const stored = window.localStorage.getItem("spm_lang");
    if (stored && translations[stored]) return stored;
    const nav = (window.navigator.language || "de").slice(0, 2);
    return translations[nav] ? nav : "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("spm_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.de,
      languages: supportedLanguages,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
